import request from '@/utils/request'

const refund = {
  // 广告退款审批列表
  listRefundVerify(query) {
    return request({
      url: '/cont/accountRefundVerify/list',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 广告退款审批详情
  getRefundVerify(arvId) {
    return request({
      url: '/cont/accountRefundVerify/' + arvId,
      method: 'get',
      options: {
        loading: true
      }
    })
  },
  // 修改
  updateRefundVerify(data) {
    return request({
      url: '/cont/accountRefundVerify',
      method: 'put',
      data: data,
      options: {
        loading: true
      }
    })
  },
  //  查询数量
  getRefundVerifyCount(query) {
    return request({
      url: '/cont/accountRefundVerify/getCountItem',
      method: 'get',
      params: query
    })
  },
  // 详情列表
  listRefundDetail(query) {
    return request({
      url: '/cont/accountRefundDetail/list',
      method: 'get',
      params: query
    })
  }
}

export default refund
